export default "__VITE_ASSET__BSpTVqkQ__"